<div class="flex flex-col items-center justify-center py-12">
  <i class="pi {{ icon() }} {{ iconSize() }} text-gray-400 mb-4"></i>
  @if (title()) {
    <p class="text-xl font-semibold text-gray-700 mb-2">
      {{ title() ?? "" | translate }}
    </p>
  }
  @if (description()) {
    <p class="text-gray-500">
      {{ description() ?? "" | translate }}
    </p>
  }
</div>
